import axios from 'axios';
import API_URL from '../../config/ApiUrl';
import { makeAutoObservable } from 'mobx';
import RootStore from '../RootStore/RootStore';
import { ServerGridConfig } from '../../config/GridConfig';
import { Notification } from '../../config/Global';

export default class AdminUsersStore {
	roleList = null;
	list_data = null;
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	adminUserDetail = null;
	searchValue = '';

	constructor() {
		makeAutoObservable(this);
		this.rootStore = new RootStore();
	}

	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			// called by the grid when more rows are required
			getRows: (params) => {
				// get data for request from server
				const payload = this.rootStore.getServerListPayload(
					params,
					this.searchValue
				);
				this.getList(payload)
					.then(({ data, totalRecords }) => {
						if (totalRecords === 0) {
							this.agGrid.api.showNoRowsOverlay();
						} else {
							this.agGrid.api.hideOverlay();
						}
						params.success({
							rowData: data,
							rowCount: totalRecords,
						});
					})
					.catch((err) => {
						params.fail(err);
					});
			},
		};
	};

	getList = async (payload) => {
		try {
			const { data } = await axios.get(
				`${API_URL.ADMIN_USERS.LIST}?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&sortBy=${payload.sortBy}&searchValue=${encodeURIComponent(payload.searchValue)}&isActive=1`
			);
			return data.data;
		} catch {}
	};

	addAdminUser = async (formData) => {
		return await axios
			.post(API_URL.ADMIN_USERS.ADD, formData)
			.then(({ data }) => {
				this.setupGrid(this.agGrid);
				return data;
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	deleteAdminUser = async ({ id, versionNo }) => {
		try {
			const encodeURL =
				'?id=' + encodeURIComponent(id) + '&versionNo=' + versionNo;
			const { data } = await axios.delete(
				API_URL.ADMIN_USERS.DELETE + encodeURL
			);
			this.setupGrid(this.agGrid);
			return data.message;
		} catch (err) {
			Promise.reject(err);
		}
	};

	getRoleList = async () => {
		const { data } = await axios.get(API_URL.ROLE.LIST);
		this.roleList = data.data;
	};

	ReadAdminUser = async (id) => {
		try {
			const { data } = await axios.get(
				API_URL.ADMIN_USERS.SINGLE + '?id=' + encodeURIComponent(id)
			);
			this.adminUserDetail = data.data;
			return data.data;
		} catch {}
	};

	editAdimnUser = async (formData) => {
		return await axios
			.put(API_URL.ADMIN_USERS.UPDATE, formData)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};
	updateUser = async (formData) => {
		return await axios
			.put(API_URL.ADMIN_USERS.CHANGEPASSWORD, formData)
			.then(({ data }) => {
				if (data.httpStatusCode == 200) {
					return data.message;
				} else {
					Notification.error({ message: data.message });
					return false;
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};
}
